import axios from "../utils/axios";

export function getDropdownValues() {
  return axios.get(`/Utils/GetDropdownValues`);
}

export function getExceptions() {
  return axios.get(`/Utils/GetExceptions`);
}
